module.exports = __webpack_public_path__ + "static/assets/f31165fc89c3fd1aedfc868b0a3263dc.svg";